import React from 'react';
import { PageHero } from '../components/PageHero';
import { TrustedByLeaders } from '../components/reviews/TrustedByLeaders';
import { ReviewForm } from '../components/ReviewForm';
export function Reviews() {
  return <>
      <PageHero breadcrumb="Reviews" title="Trusted by Leaders" lead="Selected feedback from leaders and organisations who have experienced the Qorvessa approach. Every review is published only with the reviewer’s permission." data-id="element-646" data-mp="3rdat9fhiflt" />
      <TrustedByLeaders embedded shareHref="#share" data-id="element-647" data-mp="11e2j210s5og4" />
      <section id="share" className="scroll-mt-36 bg-champagne-50" data-id="element-648" data-mp="11crdpwros8mw">
        <div className="mx-auto grid max-w-site gap-12 px-6 py-20 lg:grid-cols-12 lg:px-10 lg:py-28" data-id="element-649" data-mp="ncq5fw93dyxe">
          <div className="lg:col-span-4" data-id="element-650" data-mp="re1w853pcq76">
            <h2 className="font-serif text-4xl text-midnight-900" data-id="element-651" data-mp="rh7nnqzt0462">Share your experience</h2>
            <p className="mt-4 text-[16px] leading-relaxed text-midnight-900/70" data-id="element-652" data-mp="3863d167f233r">
              Whether we ran a search for your organisation, interviewed you, or partnered with you, your feedback helps us improve.
            </p>
            <p className="mt-6 border-t border-midnight-900/15 pt-6 text-[15px] leading-relaxed text-midnight-900/65" data-id="element-653" data-mp="3twakrhagkhv2">
              We confirm every submission before publishing and never change the meaning of what you write. You can choose to be named,
              remain anonymous, or keep your feedback private.
            </p>
          </div>
          <div className="lg:col-span-8" data-id="element-654" data-mp="ln0r1cmh5tau">
            <ReviewForm data-id="element-655" data-mp="gps99d58nra4" />
          </div>
        </div>
      </section>
    </>;
}